import { TableDescriptions } from "@interfaces/table-interface"
import { SetStateAction, useState } from "react"
import { Button } from "react-bootstrap"

interface PropsDragAndDrop {
  columns: any[]
  updateColumns: React.Dispatch<React.SetStateAction<TableDescriptions[]>>
}

export const DragInDropHideOrderColumsTableComponent: React.FC<PropsDragAndDrop> = ({columns, updateColumns}) => {

    const [dragDatafield, updateDragDatafield] = useState()

    const handleDrag = (ev: any) => {
        updateDragDatafield(ev.currentTarget.id)
    }

    const handleDrop = (ev: any) => {
        const dragBox = columns.find((box) => box.dataField === dragDatafield)
        const dropBox = columns.find((box) => box.dataField === ev.currentTarget.id)

        const dragBoxOrder = dragBox.order
        const dropBoxOrder = dropBox.order

        const newBoxState = columns.map((box) => {
            if (box.dataField === dragDatafield) {
                box.order = dropBoxOrder
            }
            else if (box.id === dropBox.id) {
                box.order = dropBoxOrder + 1
            }
            else if (box.order > dragBoxOrder && box.order < dropBoxOrder) {
                 box.order = box.order - 1
            }
            else if (box.order > dropBoxOrder && box.order < dragBoxOrder) {
                box.order = box.order + 1
            }
                
            return box
        })

        updateColumns(newBoxState)
    }

    const handleHide = (params: any) => {
        updateColumns(columns.map((value) => {
            if (value.id === params.id) {
                value.hidden = value.hidden ? false : true
            }
            return value
        }))
    }

    return (
        <>
            {columns.sort((a, b) => a.order - b.order).map((box, index) => {
                if (!box.fixed) {
                    return (
                        <Button
                            key={index}
                            draggable={true}
                            id={box.dataField}
                            onDragOver={(ev) => ev.preventDefault()}
                            onDragStart={handleDrag}
                            onDrop={handleDrop}
                            variant={box.hidden ? "secondary" : "primary"}
                            onClick={() => handleHide(box)}
                            className="m-1"
                            size={"sm"}
                            active
                        >
                            {box.text}
                        </Button>
                    )
                }

                return (<></>)
            })}
        </>
    )
}